import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function DoplnkovaSluzbaEditaceWidgetTitleDescription({
  doplnkovaSluzba,
  loading
}) {
  const message = useServerMessage();
  const { titleNew } = useMessages();

  return loading ? (
    <PlaceholderText>Kolej s montážní lávkou a kanálem</PlaceholderText>
  ) : doplnkovaSluzba ? (
    <>{`${message(doplnkovaSluzba, "nazev")}`}</>
  ) : (
    titleNew()
  );
}

DoplnkovaSluzbaEditaceWidgetTitleDescription.propTypes = {
  loading: T.bool,
  doplnkovaSluzba: T.object
};

export default React.memo(DoplnkovaSluzbaEditaceWidgetTitleDescription);
